<template>
  <div>
    {{ adjunto.estado }}
    <v-menu offset-y left v-if="$store.getters.isSafRole">
      <template slot="activator">
        <v-btn color="darkgrey" flat icon class="button-element"><v-icon>arrow_drop_down</v-icon></v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in adjunto.estadosAdjuntos" :key="index" @click="changeStatus(item, index)">
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    adjunto: Object
  },

  methods: {
    changeStatus (item) {
      this.$emit('changeCurrentStatus', item.value)
    }
  }
}
</script>

<style scoped>
.button-element {
  margin: 0;
}
</style>
